<template>
  <div :style="{ transform: `rotate(${rotation}deg)`, scale, display: 'block' }">
    <svg
      width="30"
      height="100"
      viewBox="0 0 30 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 2C2 0.895431 2.89543 -3.91405e-08 4 -8.74228e-08L26 -1.04907e-06C27.1046 -1.09736e-06 28 0.895429 28 2L2 2Z"
        :fill="borderColor" />
      <rect
        x="2.5"
        y="4.5"
        width="5"
        height="9"
        rx="0.5"
        :fill="borderColor"
        :stroke="borderColor" />
      <rect
        x="2.5"
        y="15.5"
        width="5"
        height="9"
        rx="0.5"
        :fill="borderColor"
        :stroke="borderColor" />
      <rect
        x="2.5"
        y="56.5"
        width="5"
        height="9"
        rx="0.5"
        :fill="borderColor"
        :stroke="borderColor" />
      <rect
        x="2.5"
        y="67.5"
        width="5"
        height="9"
        rx="0.5"
        :fill="borderColor"
        :stroke="borderColor" />
      <g clip-path="url(#clip0_4375_37145)">
        <mask id="path-6-inside-1_4375_37145" fill="white">
          <path d="M8 1H12V80H8V1Z" />
        </mask>
        <path d="M8 1H12V80H8V1Z" :fill="backgroundColor" />
        <path
          d="M11 1V80H13V1H11ZM9 80V1H7V80H9Z"
          :fill="borderColor"
          mask="url(#path-6-inside-1_4375_37145)" />
        <mask id="path-8-inside-2_4375_37145" fill="white">
          <path d="M18 1H22V80H18V1Z" />
        </mask>
        <path d="M18 1H22V80H18V1Z" :fill="backgroundColor" />
        <path
          d="M21 1V80H23V1H21ZM19 80V1H17V80H19Z"
          :fill="borderColor"
          mask="url(#path-8-inside-2_4375_37145)" />
      </g>
      <rect
        x="22.5"
        y="4.5"
        width="5"
        height="9"
        rx="0.5"
        :fill="borderColor"
        :stroke="borderColor" />
      <rect
        x="22.5"
        y="15.5"
        width="5"
        height="9"
        rx="0.5"
        :fill="borderColor"
        :stroke="borderColor" />
      <rect
        x="22.5"
        y="56.5"
        width="5"
        height="9"
        rx="0.5"
        :fill="borderColor"
        :stroke="borderColor" />
      <rect
        x="22.5"
        y="67.5"
        width="5"
        height="9"
        rx="0.5"
        :fill="borderColor"
        :stroke="borderColor" />
      <path d="M25 79V81H5V79H25Z" :fill="borderColor" />
      <path
        d="M3.5 89V88.5H3H2.5C1.94772 88.5 1.5 88.9477 1.5 89.5V91.5C1.5 92.0523 1.94772 92.5 2.5 92.5H3H3.5V92V89Z"
        fill=""
        :stroke="borderColor" />
      <path
        d="M26.5 81.5V97.2292C26.5 98.4939 25.5002 99.5 24.2903 99.5H5.70968C4.49977 99.5 3.5 98.4939 3.5 97.2292V81.5H26.5Z"
        :fill="backgroundColor"
        :stroke="borderColor" />
      <path
        d="M26.5 92L26.5 92.5L27 92.5L27.5 92.5C28.0523 92.5 28.5 92.0523 28.5 91.5L28.5 89.5C28.5 88.9477 28.0523 88.5 27.5 88.5L27 88.5L26.5 88.5L26.5 89L26.5 92Z"
        :fill="backgroundColor"
        :stroke="borderColor" />
      <defs>
        <clipPath id="clip0_4375_37145">
          <rect width="14" height="77" fill="white" transform="translate(8 2)" />
        </clipPath>
      </defs>
    </svg>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import BaseSvgSpotEntity from './BaseSvgSpotEntity.vue';

export default defineComponent({
  name: 'SvgTruck',
  extends: BaseSvgSpotEntity
});
</script>
